import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicRichAutocompleteComponent } from './dynamic-rich-autocomplete.component';
import { RichAutocompleteFormComponent } from './rich-autocomplete-form/rich-autocomplete-form.component';
import { MentionModule } from './angular-mentions/mention.module';
import { MaterialModule } from '../../material.module';

@NgModule({
    declarations: [
        RichAutocompleteFormComponent, DynamicRichAutocompleteComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MentionModule,
        MaterialModule
    ],
    exports: [
        RichAutocompleteFormComponent
    ],
    entryComponents: [
        DynamicRichAutocompleteComponent
    ]
})
export class RichAutocompleteModule {}